import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

export default function Title({children, align, component='h2'}) {
    return (
        <Typography component={component} variant="h6" align={align} style={{color:'#0088FE'}} gutterBottom>
            {children}
        </Typography>
    );
}

Title.propTypes = {
    children: PropTypes.node,
};